import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  inject,
  Input,
  OnInit,
  PLATFORM_ID,
  ViewChild,
  DOCUMENT,
} from '@angular/core';
import { summaryAnimation } from './summary.animation';
import { Section, TitleData } from '../../../admin/shared/public-api';
import { InnerHTMLComponent } from '../../../shared/components/inner-html/inner-html.component';

@Component({
  selector: 'app-summary',
  imports: [CommonModule, InnerHTMLComponent],
  templateUrl: './summary.component.html',
  styleUrl: './summary.component.scss',
  animations: [summaryAnimation],
})
export class SummaryComponent implements OnInit {
  @ViewChild('summary') summary: ElementRef<HTMLDivElement>;
  @ViewChild('mainUl') mainUl: ElementRef<HTMLUListElement>;
  @Input() titles: Section<TitleData>[];
  private document: Document = inject(DOCUMENT);

  titlesList: TitleListItem[] = [];
  collapsed: boolean = true;

  ngOnInit(): void {
    let currentTitle: TitleListItem;
    this.titles.forEach((title) => {
      const item: TitleListItem = {
        id: title.sectionData.id,
        title: title.sectionData.title,
        icon: title.sectionData.icon,
        subTitles: [],
      };
      if (title.componentName === 'main-title') {
        currentTitle = item;
        this.titlesList.push(currentTitle);
      } else if (title.componentName === 'secondary-title') {
        currentTitle.subTitles?.push(item);
      }
    });
  }

  collapse(): void {
    this.collapsed = !this.collapsed;
  }

  scrollToAnchor(titleId: string): void {
    if (!this.summary) {
      return;
    }
    const element = this.document.getElementById(titleId)!;
    const top = element.getBoundingClientRect().top + window.scrollY - 120;
    window.scrollTo({ top });
  }
}

type TitleListItem = {
  id: string;
  title: string;
  icon: string;
  subTitles: TitleListItem[];
};
